import React  from 'react';  

export const billingsPaymentsConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/payments',
        component: React.lazy(() => import('./TabsPage')),
      },
    ],
  }
];